var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-header" }, [
    _c(
      "div",
      { staticClass: "header-left" },
      [
        !_vm.notBack
          ? _c(
              "span",
              { staticClass: "header-back", on: { click: _vm.back } },
              [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("返回 ")]
            )
          : _vm._e(),
        _vm._l(_vm.paths, function (item, index) {
          return _c("span", { key: "path" + index }, [
            _vm._v(" " + _vm._s(item)),
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: index < _vm.paths.length - 1,
                  expression: "index < paths.length - 1",
                },
              ],
              staticClass: "el-icon-arrow-right",
            }),
          ])
        }),
      ],
      2
    ),
    _c("div", { staticClass: "header-middle" }, [_vm._v(_vm._s(_vm.title))]),
    _c("div", { staticClass: "header-right" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }